export default __webpack_public_path__ + "static/media/allTasks.8b8cf685.gif";